export enum StoreCronStateEnum {
  CHECK_ACCESS_TOKEN = 'CHECK_ACCESS_TOKEN',
  CHECK_REFRESH_TOKEN_REMAINING_TIME = 'CHECK_REFRESH_TOKEN_REMAINING_TIME',
  CHECK_LIVENESS = 'CHECK_LIVENESS',
  DISPLAY_ACCESS_TOKEN_REMAINING_TIME = 'DISPLAY_ACCESS_TOKEN_REMAINING_TIME',
  DISPLAY_REFRESH_TOKEN_REMAINING_TIME = 'DISPLAY_REFRESH_TOKEN_REMAINING_TIME',
  VIDEO_MEMORY_STORAGE_USED = 'VIDEO_MEMORY_STORAGE_USED',
}
